// src/antdviews/FirmwareView.tsx

// 升级管理页面

// 第三方
import React from 'react'
import axios from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'

// 自定义
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import FirmwareContent from './components/FirmwareContent'
import { ROLE } from '../services/Macro'
import { checker } from '../utils/Checker'
import WarnModal from './components/WarnModal'
import { AppApi, FirmwareApi } from '../services/Api'
import { strUtil } from '../utils/StrUtil'
import ConfirmModal from './components/ConfirmModal'
import { Global } from '../services/Global'
import { browserUtil } from '../utils/BrowserUtil'
import { Page } from '../services/Page'
import { FileItem } from './components/firmware/FileItem'
import { Layout } from 'antd'

interface FirmwareViewState {
    loginName: string
    showWarn: boolean
    showConfirm: boolean
    warnTitle: string
    warnInfo: string
    fileList: FileItem[]
    appList: FileItem[]
    appList4Android: FileItem[]
    appList4Pc: FileItem[]
    appList4Ios: FileItem[]
    confirmOp: () => void
}

type FirmwareViewProps = WithTranslation

const warnModalStyles = {
    content: {
        width: '480px',
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '-20px',
    },
}

class FirmwareView extends React.Component<FirmwareViewProps, FirmwareViewState> {

    state: FirmwareViewState = {
        loginName: '',
        showWarn: false,
        showConfirm: false,
        warnTitle: '本地错误',
        warnInfo: '参数错误',
        fileList: [],
        appList: [],
        appList4Android: [],
        appList4Pc: [],
        appList4Ios: [],
        confirmOp: () => {
            console.log('do nothing!')
        }
    }

    componentWillMount = (): void => {
        Global.isMobile = browserUtil.checkMobile()
    }

    componentDidMount = (): void => {
        console.log(`进入升级管理页面时的登录校验`)

        const callChecker = async (): Promise<void> => {
            const isLogin = await checker.checkLogin(ROLE.SUPER, Page.firmware)

            if (isLogin) {
                this.setState({
                    loginName: 'Admin'
                })

                this.updateFileList(true, true)
            }
        }

        callChecker()
    }

    updateFileList = (upFm: boolean, upApp: boolean): void => {
        const token = localStorage.getItem('token') || null
        const lang = localStorage.getItem('lang') || 'zh_CN'

        const apiData = {
            role: ROLE.SUPER,
            token: token,
            lang: lang.split('_')[0]
        }

        if (upFm) {
            this.ask4Dir(
                FirmwareApi.SUPER_DIRECTORY,
                apiData,
                '固件',
                (list: FileItem[]) => {
                    this.setState({
                        fileList: list
                    })
                }
            )
        }

        if (upApp) {
            this.ask4Dir(
                AppApi.SUPER_DIRECTORY,
                apiData,
                '应用',
                (list: FileItem[]) => {
                    this.setState({
                        appList: list
                    })

                    // TODO: 将应用分类
                    const appList4Android: FileItem[] = []
                    const appList4Pc: FileItem[] = []
                    const appList4Ios: FileItem[] = []

                    for (let i = 0; i < list.length; i++) {
                        const app = list[i]
                        const fileName: string = app.fileName

                        if (fileName.includes('ios')) {
                            appList4Ios.push(app)
                        } else if (
                            fileName.includes('exe') ||
                            fileName.includes('zip')
                        ) {
                            appList4Pc.push(app)
                        } else {
                            appList4Android.push(app)
                        }
                    }

                    this.setState({
                        appList4Android,
                        appList4Pc,
                        appList4Ios
                    })
                }
            )
        }
    }

    ask4Dir = async (
        api: string,
        apiData: Record<string, any>,
        type: string,
        next: (list: FileItem[]) => void
    ): Promise<void> => {
        const { t } = this.props

        try {
            const response = await axios.post(api, apiData)

            console.log(
                `获取${type}文件列表:\n`,
                response.data.data
            )

            const list: FileItem[] = response.data.data.list

            for (let i = 0; i < list.length; i++) {
                const item = list[i]

                item.updateTime = strUtil.formatTime(Number(item.updateTime))
                item.openInNewTab = item.fileName.endsWith('.json')
            }

            next(list)
        } catch (err: any) {
            console.error(err.response)

            if (err.response?.status === 404) {
                this.openWarn(
                    t('serverError'),
                    t('apiNotFound') + api
                )
            }
        }
    }

    openConfirm = (
        title: string,
        info: string,
        op: () => void
    ): void => {
        this.setState({
            warnTitle: title,
            warnInfo: info,
            showConfirm: true,
            confirmOp: () => {
                op()
                this.closeConfirm()
            }
        })
    }

    closeConfirm = (): void => {
        this.setState({
            showConfirm: false
        })
    }

    openWarn = (
        title: string,
        info: string
    ): void => {
        this.setState({
            warnTitle: title,
            warnInfo: info,
            showWarn: true
        })
    }

    closeWarn = (): void => {
        this.setState({
            showWarn: false
        })
    }

    changeLang = (): void => {
    }

    render(): React.ReactNode {
        const { t, i18n } = this.props

        return (
            // <section className="body">

            <Layout style={{ minHeight: '100vh' }}>
                {/** 弹框显示错误信息 */}
                <WarnModal
                    isMobile={Global.isMobile}
                    isOpen={this.state.showWarn}
                    onRequestClose={this.closeWarn}
                    title={t('error')}
                    subtitle={this.state.warnTitle}
                    confirm={t('confirm')}
                    customStyles={warnModalStyles}
                >
                    {this.state.warnInfo}
                </WarnModal>

                <ConfirmModal
                    isMobile={Global.isMobile}
                    isOpen={this.state.showConfirm}
                    onRequestConfirm={this.state.confirmOp}
                    onRequestCancel={this.closeConfirm}
                    title={t('warning')}
                    subtitle={this.state.warnTitle}
                    confirm={t('confirm')}
                    cancel={t('cancel')}
                    customStyles={warnModalStyles}
                >
                    {this.state.warnInfo}
                </ConfirmModal>
                <Header
                    trans={t}
                    i18n={i18n}
                    loginName={this.state.loginName}
                    changeLang={this.changeLang}
                />
                <Layout>
                    <Sidebar selectMenu={Page.firmware} trans={t} />
                    <FirmwareContent
                        trans={t}
                        handleError={this.openWarn}
                        handleConfirm={this.openConfirm}
                        updateFileList={this.updateFileList}
                        fileList={this.state.fileList}
                        appList={this.state.appList}
                        appList4Android={this.state.appList4Android}
                        appList4Pc={this.state.appList4Pc}
                        appList4Ios={this.state.appList4Ios}
                    />
                </Layout>
            </Layout>
            // </section>
        )
    }
}

export const FirmwarePage = withTranslation()(FirmwareView)